<template>
  <article class="">
    <section class="trainers__header">
      <div class="trainers__header--title">
        <div
          class="dashboard__options--reload"
          @click="findEmployees()">
          <img src="@/assets/img/icons/refresh-icon.svg" alt="">
        </div>
        <p>Empleados</p>
      </div>
      <button
        class="trainers__header--button"
        @click="$router.push({name: 'new_employee'})">Nuevo Empleado</button>
    </section>
    <section class="counter_index">
      <div
        class="counter_index__card"
        v-for="(employee, index) in employees">
        <div
          class="counter_index__card--image"
          :style="{backgroundImage: 'url(https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg)'}">
        </div>
        <div class="counter_index__card--info">
          <p><b>{{employee.name}}</b></p>
          <p><b>Email:</b> {{employee.email}}</p>
          <p><b>RUT:</b> {{employee.rut}}</p>
          <p><b>Celular:</b> {{employee.mobile}}</p>
        </div>
      </div>

      <!-- <v-data-table
        :headers="headers"
        :items="accesses"
        hide-actions
        class="elevation-1">
        <template
          slot="items"
          slot-scope="props">
          <td>{{ props.item.user }}</td>
          <td>{{ props.item.user_rut }}</td>
          <td>{{ props.item.in_date }}</td>
          <td>{{ props.item.out_date }}</td>
        </template>
      </v-data-table> -->
      <!-- <div
        v-if="accesses.length>0&& pages > 1"
        class="accessIndex__pagination">
        <v-pagination
          color="light-blue darken-3"
          v-model="pagination.page"
          :length="pages"></v-pagination>
        <label
          class="accessIndex__pagination--general_text">{{'de '+invitations_size}}</label>
        <label
          class="accessIndex__pagination--current_text"
          v-if="(pagination.page*pagination.rowsPerPage<invitations_size)">
          {{1+pagination.rowsPerPage*(pagination.page-1)+' - '+pagination.page*pagination.rowsPerPage}}
        </label>
        <label
          class="accessIndex__pagination--current_text"
          v-else>{{1+pagination.rowsPerPage*(pagination.page-1)+' - '+invitations_size+' '}}</label>
      </div> -->
    </section>
  </article>
</template>

<script>
export default {
  data(){
    return{
      employees: []
    }
  },
  methods:{
    findEmployees(){
      try {
        this.$http.get('employees',)
        .then(function(response){
          this.employees = response.body.data
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
        } catch (e) {
          alert(e.message)
        }
    }
  },
  mounted(){
    this.findEmployees()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/employees/Employees.vue